import { useApiQuery, useApiPost } from '../hooks/use-api';
import type { 
  Plan, 
  Subscription, 
  CreateTrialSubscriptionRequest, 
  SubscriptionResult,
  PaymentSessionResult 
} from '../types/subscription';

// Hook to get all available plans (public endpoint for signup)
export function usePlans() {
  return useApiQuery<Plan[]>(['plans'], '/plans');
}

// Hook to get subscription details for a studio
export function useSubscription(studioId: number) {
  return useApiQuery<Subscription>(
    ['subscription', studioId.toString()], 
    `/subscription/${studioId}`,
    {
      enabled: !!studioId,
    }
  );
}

// Hook to create a trial subscription (public endpoint for signup)
export function useCreateTrialSubscription() {
  return useApiPost<SubscriptionResult, any, CreateTrialSubscriptionRequest>(
    '/subscription/trial',
    { skipAuth: true }
  );
}

// Hook to create payment session for trial conversion
export function useCreatePaymentSession() {
  return useApiPost<PaymentSessionResult, any, { studioId: number }>(
    '/subscription/payment-session'
  );
}

// Hook to cancel subscription
export function useCancelSubscription() {
  return useApiPost<{ message: string }, any, { studioId: number; reason: string }>(
    '/subscription/cancel'
  );
}